import React from "react";
import {
  Grid,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  CloseRounded as CloseRoundedIcon
} from "@mui/icons-material";
import {
  Formik
} from "formik";
import * as Yup from "yup";

const initForm = {
  code: "",
};

class DialogTwoFa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {...initForm},
      isOpen: false,
      onSubmit: null
    };
    this.refFormik = React.createRef();
  }

  open = ({ onSubmit }) => {
    this.setState({
      values: {...initForm},
      isOpen: true,
      onSubmit,
    });
  }

  close = () => {
    this.setState({
      values: {...initForm},
      isOpen: false,
      onSubmit: null,
    })
  }

  submit = (values) => {
    this.state.onSubmit({ code: values.code });
  }

  formikSubmit = () => {
    this.refFormik.current.handleSubmit();
  }

  render() {
    const {isOpen, values} = this.state;

    if (!isOpen) return null;

    return (
      <Dialog
        open={isOpen}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle>
          Подтверждение 2FA
          <IconButton onClick={this.close}>
            <CloseRoundedIcon fontSize="small"/>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Formik
            innerRef={this.refFormik}
            initialValues={{...values}}
            validationSchema={validationSchema}
            onSubmit={this.submit}
          >{(props) => {
            const { values, errors, touched, handleChange } = props;
            return (
              <Grid container spacing={2} sx={{ mt: 0.5 }}>
                <Grid item size={12}>
                  <TextField
                    value={values.code}
                    fullWidth={true}
                    name="code"
                    label="Код подтверждения"
                    variant="outlined"
                    autoFocus
                    onChange={handleChange}
                    helperText={touched.code && errors.code ? errors.code : 'Введите код из SMS'}
                    error={Boolean(touched.code && errors.code)}
                  />
                </Grid>
              </Grid>
            )
          }}</Formik>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={this.close}>Отменить</Button>
          <Button variant="contained" onClick={this.formikSubmit}>Подтвердить</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const validationSchema = Yup.object().shape({
  code: Yup.string().required('Обязательно к заполнению'),
});

export default DialogTwoFa
